// extracted by mini-css-extract-plugin
module.exports = {"title":"AtCompanySidebarSection_title__8jDKI","content":"AtCompanySidebarSection_content__1At0d","showMoreLink":"AtCompanySidebarSection_showMoreLink__2K29a"};